import { Component, ViewChild } from '@angular/core';
import { PortalService } from './area-cliente/portal/portal.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {

  @ViewChild('notificacao') notificacao;
  @ViewChild('alerta') alerta;
  @ViewChild('layout') layout;

  areaLogada = false;

  constructor(private service: PortalService) { }

  ngOnInit() {

    let isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);

    if (!isIEOrEdge) {
      this.service.setHabilitaSuporte(true);
    } else {
      this.service.setHabilitaSuporte(false);
    }
  }

  mostraNotificacao(mensagem: string, tipo: string) {
    this.notificacao.mostra(mensagem, tipo);
  }

  mostraAlerta(mensagem?: string, titulo?: string) {
    this.alerta.show(mensagem, titulo);
  }

  alteraCollapseMenuLateral(isCollapsed: boolean) {
    this.layout.isCollapsed = isCollapsed;
  }

  trataExcecao(error) {
    let mensagem = undefined;
    try {
      mensagem = this.retornaMensagemErro(error);
    } catch (e) { }

    if (mensagem === undefined)
      mensagem = "Erro ao tentar acessar o servidor.";

    this.mostraAlerta(mensagem, "Oops!");
  }

  retornaMensagemErro(error) {

    if (error && error.erro && Array.isArray(error.erro))
      return error.erro[0].texto;

    if (error && error.erro && error.erro.texto)
      return error.erro.texto;

    if (error && error.erro)
      return error.erro;

    return undefined;
  }
} 



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/app.component.ts